module.exports = __webpack_public_path__ + "img/left2.66e215e8.png";